import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContentWrapper, PageHeader, PageDescription } from '../main/LayoutStyles';
import { Tag, RatingContainer } from '../main/CommonStyles';
import {
    ReviewsPageWrapper,
    PsychologistCard,
    PsychologistAvatar,
    PsychologistInfo,
    PsychologistActions,
    ViewProfileButton,
    BookAppointmentButtonReview,
} from '../review/ReviewsStyles';
import { Star, MapPin, User, Loader2, AlertTriangle } from 'lucide-react';
import { useTheme } from 'styled-components'; // <-- NOWY IMPORT
import apiClient from '../services/api';

const StarRating = ({ rating = 0 }) => {
    const theme = useTheme(); // <-- POPRAWKA: Użycie hooka useTheme
    const totalStars = 5;
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;
    const emptyStars = totalStars - fullStars - (halfStar ? 1 : 0);

    return (
        <RatingContainer>
            {[...Array(fullStars)].map((_, i) => <Star key={`full-${i}`} fill={theme.colors.secondary} size={18} />)}
            {halfStar && <Star key="half" fill={theme.colors.secondary} style={{ clipPath: 'inset(0 50% 0 0)' }} size={18} />}
            {[...Array(emptyStars)].map((_, i) => <Star key={`empty-${i}`} fill={theme.colors.borderColor} size={18} />)}
            <span className="rating-value">{rating.toFixed(1)}</span>
        </RatingContainer>
    );
};

const PsychologistListPage = () => {
    const theme = useTheme(); // <-- POPRAWKA: Użycie hooka useTheme
    const [psychologists, setPsychologists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPsychologists = async () => {
            setLoading(true);
            try {
                const response = await apiClient.get('/psychologists');
                setPsychologists(response.data);
            } catch (err) {
                setError('Nie udało się pobrać listy psychologów.');
                console.error("Błąd pobierania psychologów:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchPsychologists();
    }, []);

    const handleViewProfile = (id) => {
        navigate(`/app/psychologist/${id}`);
    };

    return (
        <PageContentWrapper className="custom-scrollbar">
            <PageHeader>Nasi Specjaliści</PageHeader>
            <PageDescription>
                Znajdź specjalistę dopasowanego do Twoich potrzeb. Przeglądaj profile i umów się na wizytę.
            </PageDescription>

            {loading && <div style={{ textAlign: 'center' }}><Loader2 className="icon-spin" size={32} /> Ładowanie...</div>}
            {error && <div style={{ color: 'red' }}><AlertTriangle /> {error}</div>}

            {!loading && !error && (
                <ReviewsPageWrapper>
                    {psychologists.length > 0 ? psychologists.map(psy => (
                        <PsychologistCard key={psy.id}>
                            {psy.userImageUrl ? (
                                <PsychologistAvatar src={psy.userImageUrl} alt={psy.username} />
                            ) : (
                                <div style={{width: 100, height: 100, borderRadius: '50%', background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <User size={50} color="#ccc" />
                                </div>
                            )}
                            <PsychologistInfo>
                                <h3>{`${psy.firstName} ${psy.lastName}`}</h3>
                                <p style={{fontWeight: 500, color: theme.colors.textMedium, marginTop: '-5px'}}>{psy.professionalTitle}</p>
                                <StarRating rating={psy.rating || 0} />
                                <div className="specialties" style={{ marginTop: theme.spacing.sm }}>
                                    {(psy.specializations || "").split(',').map(spec => spec.trim() && <Tag key={spec}>{spec}</Tag>)}
                                </div>
                                {psy.officeAddress && <div className="location">
                                    <MapPin size={16} /> {psy.officeAddress}
                                </div>}
                            </PsychologistInfo>
                            <PsychologistActions>
                                <ViewProfileButton onClick={() => handleViewProfile(psy.id)}>
                                    Zobacz profil
                                </ViewProfileButton>
                                <BookAppointmentButtonReview onClick={() => navigate('/app/appointments')}>
                                    Umów wizytę
                                </BookAppointmentButtonReview>
                            </PsychologistActions>
                        </PsychologistCard>
                    )) : <p>Obecnie nie ma dostępnych publicznych profili psychologów.</p>}
                </ReviewsPageWrapper>
            )}
        </PageContentWrapper>
    );
};

export default PsychologistListPage;